import React, { ReactElement } from "react";
import dynamic from "next/dynamic";
import { LoadingSkeleton } from "@kunduz/ui";

const QuestionAnswer = dynamic(
  () => {
    return import("./questionAnswer");
  },
  {
    ssr: false,
    loading: () => (
      <LoadingSkeleton style={{ height: 354, marginBottom: 32 }} />
    ),
  }
);

const QuestionAnswerLoader = (props): ReactElement => {
  return <QuestionAnswer {...props} />;
};

export default QuestionAnswerLoader;
